/** Shared utilities for task structural mutations in Firestore. */
import { getTasksByParent } from '@/services/taskService';
import { updateTaskInBatch } from '@/services/taskMutations';

const MAX_RECURSION_DEPTH = 10;

export const updateChildrenPathsRecursively = async (
  currentParentId,
  newParentMaterializedPath,
  userId,
  batch,
  depth = 0,
) => {
  // Safety guard against infinite recursion in malformed hierarchies
  if (depth > MAX_RECURSION_DEPTH) {
    console.error(
      `Max recursion depth reached for parent ${currentParentId}. Potential circular reference detected.`,
    );
    return;
  }

  const childrenDocs = await getTasksByParent(currentParentId, userId);

  for (const childDoc of childrenDocs) {
    const childData = childDoc.data();
    const newChildMaterializedPath = `${newParentMaterializedPath}${childData.orderKey}.`;

    updateTaskInBatch(batch, childDoc.id, {
      materializedPath: newChildMaterializedPath,
    });

    await updateChildrenPathsRecursively(
      childDoc.id,
      newChildMaterializedPath,
      userId,
      batch,
      depth + 1,
    );
  }
};
